import { IconProps } from "rivals/components/shared/Icons/iconPropsTypes";

function Share({ style }: IconProps): JSX.Element {
  return (
    <svg
      fill="none"
      height="31"
      style={style}
      viewBox="0 0 30 31"
      width="30"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7981_7692)">
        <circle
          cx="15"
          cy="15.5"
          fill="white"
          r="14.75"
          stroke="#9C9C9C"
          strokeWidth="0.5"
        />
        <path
          d="M11.9808 15.5C11.9808 15.7157 11.9329 15.9073 11.885 16.099L15.9105 18.9265C16.27 18.6629 16.7252 18.4952 17.2045 18.4952C18.4505 18.4952 19.4569 19.5016 19.4569 20.7476C19.4569 21.9936 18.4505 23 17.2045 23C15.9585 23 14.9521 21.9936 14.9521 20.7476C14.9521 20.5319 15 20.3403 15.0479 20.1486L11.0463 17.3211C10.6869 17.5847 10.2316 17.7524 9.7524 17.7524C8.50639 17.7524 7.5 16.746 7.5 15.5C7.5 14.254 8.50639 13.2476 9.7524 13.2476C10.2316 13.2476 10.6869 13.4153 11.0463 13.6789L15.0719 10.8514C15.024 10.6597 14.976 10.4681 14.976 10.2524C14.976 9.00639 15.9824 8 17.2284 8C18.4744 8 19.4808 9.00639 19.4808 10.2524C19.4808 11.4984 18.4744 12.5048 17.2284 12.5048C16.7492 12.5048 16.2939 12.3371 15.9345 12.0735L11.885 14.901C11.9569 15.0927 11.9808 15.2843 11.9808 15.5Z"
          fill="#363636"
        />
      </g>
      <defs>
        <clipPath id="clip0_7981_7692">
          <rect
            fill="white"
            height="30"
            transform="translate(0 0.5)"
            width="30"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Share;
